import { getLanguages } from "../../../../../../../../../shared/api/catalogs";

interface GetLanguagesParams {
	buyer_id: number;
	customer_id: string;
}

export const fetchLanguages = async (params: GetLanguagesParams) => {
	const data = await getLanguages(params);
	return data;
};
